<div class="wrapper">
  <div *ngIf="formTypeOptions?.length" class="heading text-type-2">
    {{
      formTypeOptions.length === 1 ? formTypeOptions[0]?.name + ' Form' : data?.control_form?.label || 'Add a form'
    }}
  </div>
  <app-dropdown
    *ngIf="!readOnly && !isPreview"
    (checkForErrors)="checkForErrors($event)"
    [enableDetailedOptionView]="false"
    [enableSearch]="true"
    [error]="errorMessages['formType']"
    [options]="formTypeOptions"
    [parentFormGroup]="form"
    class="mb-[20px]"
    controlName="formType"
    label="Form Type"
    placeholder="Search"
  />
  @if (launcherMessage) {
    <p class="text-type-14 text-[#60698B] mb-[20px]" role="status" data-testid="form-launcher-message">{{ launcherMessage }}</p>
  }
  <div *ngIf="headerFields?.length"
       class="header-section-form-fields border-[1px] border-[#E9ECF4] rounded-[4px] px-[12px] pt-[21px] mb-[20px]">
    @if (autofillCard; as card) {
      <!-- Figma "Autofilled" summary card (35290:22030): what the linked map feature filled, until the user edits it all. -->
      <div class="autofill-card" role="status" data-testid="form-autofill-card">
        <div class="autofill-card-tile" aria-hidden="true">
          <!-- Figma "Location / Blue filled" -->
          <svg width="24" height="24" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M19 9.56174C19 5.93661 15.8673 3 12 3C8.13318 3 5 5.93661 5 9.56174C5 13.2525 11.9996 22 11.9996 22C11.9996 22 19 13.3042 19 9.56174V9.56174Z" fill="#1036D6"/></svg>
        </div>
        <div class="autofill-card-text">
          <p class="autofill-card-title">{{ card.title }}</p>
          <p class="autofill-card-subtitle">{{ card.subtitle }}</p>
        </div>
      </div>
    }
    <ng-container *ngFor="let hf of headerFields; let i = index">
      <ng-container [ngSwitch]="hf?.componentType">
        <!-- Text Input -->
        <app-text-input
          *ngSwitchCase="'string'"
          [labelBadge]="prefillCaptions.isAutofilled(hf?.name) ? autofilledBadge : ''"
          [controlName]="hf?.name"
          [id]="hf?.name+'_'+ i"
          [label]="hf?.label + (hf?.uom ? ' (' + hf?.uom + ')' : '')"
          [parentFormGroup]="form"
          class="mb-[20px]"
        />
        <!-- Number Type -->
        <app-number-input
          *ngSwitchCase="'number'"
          [labelBadge]="prefillCaptions.isAutofilled(hf?.name) ? autofilledBadge : ''"
          [controlName]="hf?.name"
          [id]="hf?.name+'_'+ i"
          [isDecimalAllowed]="true"
          [label]="hf?.label + (hf?.uom ? ' (' + hf?.uom + ')' : '')"
          [parentFormGroup]="form"
          class="mb-[20px]"
        />
        <!-- Dropdown Type -->
        <app-dropdown
          *ngSwitchCase="'dropdown'"
          [labelBadge]="prefillCaptions.isAutofilled(hf?.name) ? autofilledBadge : ''"
          [controlName]="hf?.name"
          [enableMultiple]="hf?.multi_select"
          [enableOthers]="!!hf?.allow_other"
          [enableSearch]="true"
          [id]="hf?.name+'_'+ i"
          [label]="hf?.label + (hf?.uom ? ' (' + hf?.uom + ')' : '')"
          [options]="hf?.ui_config?.pick_list_values?.length ? hf?.ui_config?.pick_list_values : picklistOptions[hf?.name]"
          [parentFormGroup]="form"
          [selectionString]="form.controls[hf?.name]?.value?.length > 1 ? hf?.label + 's' : hf.label "
          [showCount]="hf.name === 'activity_id' || hf.name === '_bid_item'"
          class="mb-[20px]"
        />
        <app-text-input
          [controlName]="hf?.name+'_others'"
          [id]="hf?.name+'_others'+'_'+ i"
          [label]="hf?.label+' '+'others'"
          [parentFormGroup]="form"
          class="mb-[20px]"
        />
        <!-- Date Type -->
        <app-date-picker
          *ngSwitchCase="'date'"
          [labelBadge]="prefillCaptions.isAutofilled(hf?.name) ? autofilledBadge : ''"
          [controlName]="hf?.name"
          [id]="hf?.name+'_'+ i"
          [label]="hf?.label + (hf?.uom ? ' (' + hf?.uom + ')' : '')"
          [parentFormGroup]="form"
          class="mb-[20px]"
        />
        <!-- Time Type -->
        <app-time-select
          *ngSwitchCase="'time'"
          [labelBadge]="prefillCaptions.isAutofilled(hf?.name) ? autofilledBadge : ''"
          [amPmControlName]="hf?.name+'_am_pm'"
          [controlName]="hf?.name"
          [id]="hf?.name+'_'+ i"
          [label]="hf?.label + (hf?.uom ? ' (' + hf?.uom + ')' : '')"
          [parentFormGroup]="form"
          [timePeriodControlName]="hf?.name+'_timePeriod'"
          class="mb-[20px]"
        />
        <!-- Text Area Type -->
        <app-text-area
          *ngSwitchCase="'textarea'"
          [labelBadge]="prefillCaptions.isAutofilled(hf?.name) ? autofilledBadge : ''"
          [controlName]="hf?.name"
          [id]="hf?.name+'_'+ i"
          [label]="hf?.label + (hf?.uom ? ' (' + hf?.uom + ')' : '')"
          [parentFormGroup]="form"
          class=" col-span-2 mb-[20px]"
        />
        <!-- Boolean -->
        <div
          *ngSwitchCase="'boolean'"
          [id]="hf?.name+'_'+ i"
          class="flex flex-row justify-between items-center  gap-[20px] w-full col-span-2 mb-[30px]">
          <div class="boolean-label text-type-13 ">
            {{ hf?.label + (hf?.uom ? ' (' + hf?.uom + ')' : '') }}
          </div>
          <mat-slide-toggle
            (change)="onToggle($event, hf?.name)"
            [checked]="form?.controls?.[hf?.name]?.value"
            [disableRipple]="false"
            class="slide-toggle-btn"
            color="primary"
          />
        </div>
      </ng-container>
    </ng-container>
  </div>
  <!--  Add Entry-->
  <div
    (click)="addEntry()"
    *ngIf="form?.controls?.['formType']?.value && lineFields?.length && !dewcForm && !readOnly"
    class="flex flex-row justify-between items-center mb-[20px]"
  >
    <div class="section-heading text-type-8 !text-[#60698b]"></div>
    <div class="add-station-block flex flex-row justify-start items-center cursor-pointer w-fit">
      <mat-icon class="icon mr-[5px]" svgIcon="blue-plus" />
      <span class="text-type-9">{{ formTypeDetails?.ui_config?.add_line_label || 'Add entry' }}</span>
    </div>
  </div>
  <!-- Lines Accordion -->
  <ng-container *ngIf="lineKeys?.length && formTypeDetails?.ui_config?.lines?.fields?.length">
    <div *ngFor="let lineKey of lineKeys; let last = last">
      <div [class.is-expanded]="selectedLineId === lineKey?.key"
           [id]="lineKey?.key"
           class="line-accordion mb-[20px]">
        <div class="line-header flex justify-between items-center">
          <div
            (click)="selectLine(lineKey?.key)"
            class="left flex justify-start items-center gap-[12px] grow"
          >
            <div class="details flex flex-col">
              <div class="line-accordion-heading text-type-8">
                {{ lineKey?.lineName }}
              </div>
            </div>
          </div>
          <div class="right flex justify-center items-center gap-[10px]">
            <div class="chevron">
              <mat-icon
                (click)="selectLine(lineKey?.key)"
                [svgIcon]="selectedLineId === lineKey?.key ? 'chevron-up' : 'chevron-down'"
                class="chevron-icon"
              />
            </div>
            <div class="menu-section" *ngIf="!readOnly">
              <mat-icon
                [matMenuTriggerFor]="menu"

                class="menu-icon"
              >
                more_horiz
              </mat-icon>
              <mat-menu #menu="matMenu">
                <button (click)="deleteLineEntry(lineKey?.key)" mat-menu-item>
                  <mat-icon svgIcon="trash" />
                  {{ formTypeDetails?.ui_config?.delete_line_label || 'Delete entry' }}
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
        <div class="line-content">
          <ng-container>
            <div class="fields-row input-block grid grid-cols-2 gap-x-[20px] gap-y-[20px]">
              <ng-container *ngFor="let lf of lineFields; let i = index">
                <ng-container [ngSwitch]="lf?.type">
                  <!-- String Type -->
                  <ng-container *ngSwitchCase="'string'">
                    <ng-container *ngIf="lf?.pick_list || lf?.componentType === 'dropdown' || (lf?.ui_config?.pick_list_values?.length); else textInput">
                      <!-- Dropdown -->
                      <app-dropdown
                        [controlName]="lf?.name"
                        [enableMultiple]="lf?.multi_select"
                        [enableOthers]="!!lf?.allow_other"
                        [enableSearch]="true"
                        [id]="lf?.name+'_'+ i"
                        [label]="lf?.label + (lf?.uom ? ' (' + lf?.uom + ')' : '')"
                        [options]="lf?.ui_config?.pick_list_values?.length ? lf?.ui_config?.pick_list_values : picklistOptions[lf?.name]"
                        [parentFormGroup]="lineFormGroup"
                        class=""
                      />
                      <ng-container *ngIf="this.form.controls[lf?.name+'_others']">
                        <app-text-input
                          [controlName]="lf?.name+'_others'"
                          [id]="lf?.name+'_others'+ i"
                          [label]="lf?.label+' others'"
                          [parentFormGroup]="lineFormGroup"
                          class=""
                        />
                      </ng-container>
                    </ng-container>
                    <ng-template #textInput>
                      <ng-container *ngIf="!lf?.display_only; else displayOnly">
                        <!-- Text Input -->
                        <app-text-input
                          [controlName]="lf?.name"
                          [id]="lf?.name+'_'+ i"
                          [label]="lf?.label + (lf?.uom ? ' (' + lf?.uom + ')' : '')"
                          [parentFormGroup]="lineFormGroup"
                          class=""
                        />
                      </ng-container>
                      <ng-template #displayOnly>
                        <!-- View Only Input -->
                        <app-view-field
                          [id]="lf?.name+'_'+ i"
                          [label]="lf?.label + (lf?.uom ? ' (' + lf?.uom + ')' : '')"
                          [value]="lineFormGroup?.controls[lf?.name]?.value"
                          class="mb-[40px]"
                        />
                      </ng-template>
                    </ng-template>
                  </ng-container>
                  <!-- Number Type -->
                  <ng-container *ngSwitchCase="'number'">
                    <ng-container *ngIf="!lf?.display_only; else displayOnly">
                      <!-- Number Type -->
                      <app-number-input
                        [controlName]="lf?.name"
                        [id]="lf?.name+'_'+ i"
                        [isDecimalAllowed]="true"
                        [label]="lf?.label + (lf?.uom ? ' (' + lf?.uom + ')' : '')"
                        [parentFormGroup]="lineFormGroup"
                        class="mb-[20px]"
                      />
                    </ng-container>
                    <ng-template #displayOnly>
                      <!-- View Only Input -->
                      <app-view-field
                        [id]="lf?.name+'_'+ i"
                        [label]="lf?.label + (lf?.uom ? ' (' + lf?.uom + ')' : '')"
                        [value]="lineFormGroup?.controls[lf?.name]?.value"
                        class="mb-[40px]"
                      />
                    </ng-template>
                  </ng-container>
                  <!-- Date Type -->
                  <app-date-picker
                    *ngSwitchCase="'date'"
                    [controlName]="lf?.name"
                    [id]="lf?.name+'_'+ i"
                    [label]="lf?.label + (lf?.uom ? ' (' + lf?.uom + ')' : '')"
                    [parentFormGroup]="lineFormGroup"
                    class=""
                  />
                  <!-- Time Type -->
                  <app-time-select
                    *ngSwitchCase="'time'"
                    [amPmControlName]="lf?.name+'_am_pm'"
                    [controlName]="lf?.name"
                    [id]="lf?.name+'_'+ i"
                    [label]="lf?.label + (lf?.uom ? ' (' + lf?.uom + ')' : '')"
                    [parentFormGroup]="lineFormGroup"
                    [timePeriodControlName]="lf?.name+'_timePeriod'"
                    class=""
                  />
                  <!-- Text Area Type -->
                  <app-text-area
                    *ngSwitchCase="'textarea'"
                    [controlName]="lf?.name"
                    [id]="lf?.name+'_'+ i"
                    [label]="lf?.label + (lf?.uom ? ' (' + lf?.uom + ')' : '')"
                    [parentFormGroup]="lineFormGroup"
                    class=" col-span-2"
                  />
                  <!-- Boolean -->
                  <div
                    *ngSwitchCase="'boolean'"
                    [id]="lf?.name+'_'+ i"
                    class="flex flex-row justify-between items-center  gap-[20px] w-full col-span-2 mb-[20px]">
                    <div class="label text-type-13 ">
                      {{ lf?.label + (lf?.uom ? ' (' + lf?.uom + ')' : '') }}
                    </div>
                    <mat-slide-toggle
                      (change)="onToggleLf($event, lf?.name)"
                      [checked]="lineFormGroup?.controls?.[lf?.name]?.value"
                      [disableRipple]="false"
                      class="slide-toggle-btn"
                      color="primary"
                    />
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </ng-container>
          <app-pictures-section
            (onDelete)="deletePicture($event)"
            *ngIf="selectedMediaFiles?.length"
            [pictures]="selectedMediaFiles"
            [isEditable]="!readOnly"
            class="pictures-section mb-[40px]"
          />
        </div>
      </div>
      <hr *ngIf="!last" class="hr mb-[20px]">
    </div>
  </ng-container>
  <div
    *ngIf="displayStationRange"
    class="location-station-section mb-[40px]"
  >
    <div class="location-station-header flex justify-between items-center mb-[12px]">
      <div class="location-station-label">Location station:</div>
      <mat-icon
        *ngIf="!readOnly"
        [matMenuTriggerFor]="locationStationMenu"
        class="location-station-menu-icon"
      >more_horiz
      </mat-icon>
      <mat-menu #locationStationMenu="matMenu">
        <button (click)="openLocationPicker()" mat-menu-item>
          <mat-icon svgIcon="marker-outline" />
          Add location
        </button>
        <button *ngIf="hasPublishedSheets" (click)="markOnDrawing()" mat-menu-item data-testid="location-menu-mark-on-drawing">
          <mat-icon svgIcon="markup-line" />
          Mark on drawing
        </button>
        <button (click)="openStationRangeDetails()" mat-menu-item>
          <mat-icon svgIcon="plus" />
          Add station
        </button>
        <button *ngIf="showLocationOrStationSection()" (click)="deleteLocation()" mat-menu-item>
          <mat-icon svgIcon="trash" />
          Clear
        </button>
      </mat-menu>
    </div>

    <app-location-station-card
      *ngIf="showLocationOrStationSection(); else addStationRange"
      (cardClicked)="openLocationOrStationDetails()"
      (onDelete)="deleteLocation()"
      [form]="form"
      [latitude]="form?.controls?.latitude?.value"
      [longitude]="form?.controls?.longitude?.value"
      [stationRange]="stationRangeDisplayValue"
      [hideLabel]="true"
      [isEditable]="!readOnly"
      [useExternalClickHandler]="true"
      [recordLabel]="'form'"
      [featureSource]="featureSource"
    />
    <ng-template #addStationRange>
      <div
        *ngIf="!readOnly"
        [matMenuTriggerFor]="locationStationMenu"
        class="station-range flex flex-row flex-wrap justify-start items-center cursor-pointer"
        data-testid="control-form-add-location-station-range"
      >
        <mat-icon class="add-icon mr-[8px]" svgIcon="plus" />
        Add location or station
      </div>
    </ng-template>
  </div>
  <div
    *ngIf="generalQuestions?.length"
    class="general-questions-section mb-[40px]"
  >
    <div class="general-questions-section-label">General Questions:</div>
    <ng-container *ngIf="data?.lines?.length || displayGeneralQuestionsDetails; else formNotAnswered">
      <div
        (click)="openQuestionDetails(generalQuestions,'generalQuestions')"
        class="general-questions flex flex-col justify-center"
      >
        <div class="w-full justify-start">
          {{ data?.segregateLinesBySection?.general?.length || answeredGeneralQuestion?.length || 0 }}
          /{{ generalQuestions?.length }}
          answered
        </div>
        <div class="answers-type-panel flex flex-row justify-start items-start w-1/2">
          <div class="answer w-1/3">
            {{ responseOptions?.length > 0 ? responseOptions[0] : 'Pass' }}
            : {{ generalQuestionPositiveArray.length || 0 }}
          </div>

          <div class="answer w-1/3">
            {{ responseOptions?.length > 1 ? responseOptions[1] : 'Fail' }}
            : {{ generalQuestionNegativeArray.length || 0 }}
          </div>

          <div class="answer w-1/3">
            {{ responseOptions?.length > 2 ? responseOptions[2] : 'N/A' }}: {{ generalQuestionNaArray.length || 0 }}
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #formNotAnswered>
      <div
        (click)="openQuestionDetails(generalQuestions,'generalQuestions')"
        class="general-questions flex flex-row flex-wrap justify-start items-center"
      >
        <mat-icon class="question-icon mr-[8px]" svgIcon="form" />
        {{ generalQuestions?.length }} {{ generalQuestions?.length === 1 ? 'question' : 'questions' }}
      </div>
    </ng-template>

  </div>
  <app-dropdown
    (checkForErrors)="checkForErrors($event)"
    *ngIf="displayFrequency"
    [enableDetailedOptionView]="false"
    [enableMultiple]="true"
    [enableSearch]="true"
    [error]="errorMessages['frequency']"
    [options]="frequencyOptions"
    [parentFormGroup]="form"
    class="mb-[25px]"
    controlName="frequency"
    label="Section"
    placeholder="Search"
  />
  <div
    *ngIf="displayFrequencyQuestions"
    class="frequency-questions-section mb-[40px]"
  >
    <ng-container *ngFor="let section of selectedFrequencyType">
      <div class="frequency-questions-section-label">
        {{ section.description }}
      </div>
      <ng-container
        *ngIf="frequencyQuestionSummary[section.name]?.answered.length > 0  || data?.segregateLinesBySection?.[section.name]?.length > 0; else frequencyFormNotAnswered">
        <div
          (click)="openQuestionDetails(sectionQuestions[section.name],'frequencyQuestions', section)"
          class="frequency-questions flex flex-col justify-center mb-[18px]"
        >
          <div class="w-full justify-start">
            {{ frequencyQuestionSummary[section.name]?.answered?.length || data?.segregateLinesBySection?.[section.name]?.length || 0 }}
            /{{ sectionQuestions[section.name]?.length }}
            answered
          </div>
          <div class="answers-type-panel flex flex-row justify-start items-start w-1/2">
            <div class="answer w-1/3">
              {{ responseOptions?.length > 0 ? responseOptions[0] : 'Pass' }}
              : {{ frequencyQuestionSummary[section.name]?.pass?.length || 0 }}
            </div>

            <div class="answer w-1/3">
              {{ responseOptions?.length > 1 ? responseOptions[1] : 'Fail' }}
              : {{ frequencyQuestionSummary[section.name]?.fail?.length || 0 }}
            </div>

            <div class="answer w-1/3">
              {{ responseOptions?.length > 2 ? responseOptions[2] : 'N/A' }}
              : {{ frequencyQuestionSummary[section.name]?.na?.length || 0 }}
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #frequencyFormNotAnswered>
        <div
          (click)="openQuestionDetails(sectionQuestions[section.name],'frequencyQuestions', section)"
          class="frequency-questions flex flex-row flex-wrap justify-start items-center mb-[40px]"
        >
          <mat-icon class="question-icon mr-[8px]" svgIcon="form"></mat-icon>
          {{ sectionQuestions[section.name]?.length }} {{ sectionQuestions[section.name]?.length === 1 ? 'question' : 'questions' }}
        </div>
      </ng-template>

    </ng-container>
  </div>
  <div
    *ngIf="this.displaySignature"
    class="signature-section mb-[40px]"
  >
    <div class="signature-section-label">Signature:</div>
    <div
      *ngIf="signatureViews?.length"
      class="signatures flex flex-col justify-start"
    >
      <div
        *ngFor="let sv of signatureViews"
        class="eachSignature"
      >
        <div
          (click)="openSignatureDetails(sv.sourceIndex)"
          class="signature-content"
        >
          <div class="role">{{ sv.role || 'Signature' }}</div>
          <!-- Drawn signature: render the captured image, bounded, plus the
               printed name beneath it (when captured) for legibility. -->
          <ng-container *ngIf="sv.method === 'drawn' && sv.imageUrl; else nonDrawn">
            <img
              [src]="sv.imageUrl"
              [alt]="(sv.role || 'Signature') + ' signature'"
              class="signature-image"
            />
            <div *ngIf="sv.text" class="signature-printed-name">{{ sv.text }}</div>
          </ng-container>
          <ng-template #nonDrawn>
            <!-- Typed-with-font: best-effort render in the chosen font. -->
            <div
              *ngIf="sv.method === 'typed_font' && sv.text; else plainSignature"
              [style.font-family]="sv.fontFamily"
              class="signature-name signature-name--font"
            >{{ sv.text }}
            </div>
            <ng-template #plainSignature>
              <!-- Typed / legacy / drawn-without-image: plain text fallback. -->
              <div class="signature-name">{{ sv.text || 'Signed' }}</div>
            </ng-template>
          </ng-template>
          <div *ngIf="sv.signedAt" class="signature-signed-at">Signed {{ sv.signedAt }}</div>
        </div>
        <mat-icon
          *ngIf="!readOnly"
          (click)="removeSignature(sv.sourceIndex)"
          class="signature-remove"
          svgIcon="trash"
        />
      </div>
    </div>
    <div
      *ngIf="!readOnly"
      (click)="openSignatureDetails(null)"
      class="signature flex flex-row flex-wrap justify-start items-center"
    >
      <mat-icon class="add-icon mr-[8px]" svgIcon="plus" />
      Add Signature
    </div>
  </div>
  <!-- Section Accordion -->
  <div *ngFor="let sa of sectionAccordions; let last = last">
    <div [class.is-expanded]="selectedSectionId === sa?.name"
         [id]="sa?.name"
         class="section-accordion mb-[20px]">
      <div class="section-accordion-header flex justify-between items-center">
        <div
          (click)="selectSection(sa)"
          class="left flex justify-start items-center gap-[12px] grow"
        >
          <div class="details flex flex-col">
            <div class="section-accordion-heading text-type-8">
              {{ sa?.label }}
            </div>
          </div>
        </div>
        <div class="right flex justify-center items-center gap-[10px]">
          <div class="chevron">
            <mat-icon
              (click)="selectSection(sa)"
              [svgIcon]="selectedSectionId === sa.name ? 'chevron-up' : 'chevron-down'"
              class="chevron-icon"
            />
          </div>
        </div>
      </div>
      <div class="section-accordion-content">
        <div
          *ngIf="!readOnly"
          (click)="addSectionLine(sa)"
          class="flex flex-row justify-between items-center mb-[20px]"
        >
          <div class="section-heading text-type-8 !text-[#60698b]"></div>
          <div class="add-station-block flex flex-row justify-start items-center cursor-pointer w-fit">
            <mat-icon class="icon mr-[5px]" svgIcon="blue-plus" />
            <span class="text-type-9">{{ formTypeDetails?.ui_config?.add_line_label || 'Add entry' }}</span>
          </div>
        </div>
        <ng-container>
          <!-- Section Line Accordion -->
          <ng-container *ngFor="let sslk of selectedSectionLineKeys">
            <div [class.is-expanded]="selectedSectionLineBlockId === sslk?.key"
                 [id]="sslk?.key"
                 class="section-line-accordion border-[1px] border-[#E9ECF4] rounded-[4px] px-[12px] mb-[20px]">
              <div class="section-line-accordion-header flex justify-between items-center">
                <div
                  (click)="selectSectionLineBlock(sslk?.key)"
                  class="left flex justify-start items-center gap-[12px] grow"
                >
                  <div class="details flex flex-col">
                    <div class="section-line-accordion-heading text-type-8">
                      {{ sslk?.lineLabel }}
                    </div>
                  </div>
                </div>
                <div class="right flex justify-center items-center gap-[10px]">
                  <div class="chevron">
                    <mat-icon
                      (click)="selectSectionLineBlock(sslk?.key)"
                      [svgIcon]="selectedSectionLineBlockId === sslk?.key ? 'chevron-up' : 'chevron-down'"
                      class="chevron-icon"
                    />
                  </div>
                </div>
              </div>
              <div class="section-line-accordion-content">
                <ng-container>
                  <div class="fields-row input-block grid grid-cols-2 gap-x-[20px] gap-y-[20px]">
                    <ng-container *ngFor="let field of sectionTypeFieldsMap[sa?.name]; let i = index">
                      <ng-container [ngSwitch]="field?.componentType">
                        <!-- Text Input -->
                        <ng-container *ngSwitchCase="'string'">
                          <ng-container *ngIf="!field?.display_only; else displayOnly">
                            <app-text-input
                              [controlName]="field?.name"
                              [id]="field?.name+'_'+ i"
                              [label]="field?.label + (field?.uom ? ' (' + field?.uom + ')' : '')"
                              [parentFormGroup]="selectedSectionLineBlockFormGroup"
                              class="mb-[20px]"
                            />
                          </ng-container>
                          <ng-template #displayOnly>
                            <!-- View Only Input -->
                            <app-view-field
                              [id]="field?.name+'_'+ i"
                              [label]="field?.label + (field?.uom ? ' (' + field?.uom + ')' : '')"
                              [value]="selectedSectionLineBlockFormGroup?.controls[field?.name]?.value"
                              class="mb-[40px]"
                            />
                          </ng-template>
                        </ng-container>
                        <!-- Number Type -->
                        <ng-container *ngSwitchCase="'number'">
                          <ng-container *ngIf="!field?.display_only; else displayOnly">
                            <app-number-input
                              [controlName]="field?.name"
                              [id]="field?.name+'_'+ i"
                              [isDecimalAllowed]="true"
                              [label]="field?.label + (field?.uom ? ' (' + field?.uom + ')' : '')"
                              [parentFormGroup]="selectedSectionLineBlockFormGroup"
                              class="mb-[20px]"
                            />
                          </ng-container>
                          <ng-template #displayOnly>
                            <!-- View Only Input -->
                            <app-view-field
                              [id]="field?.name+'_'+ i"
                              [label]="field?.label + (field?.uom ? ' (' + field?.uom + ')' : '')"
                              [value]="selectedSectionLineBlockFormGroup?.controls[field?.name]?.value"
                              class="mb-[40px]"
                            />
                          </ng-template>
                        </ng-container>
                        <!-- Dropdown Type -->
                        <app-dropdown
                          *ngSwitchCase="'dropdown'"
                          [controlName]="field?.name"
                          [id]="field?.name+'_'+ i"
                          [label]="field?.label + (field?.uom ? ' (' + field?.uom + ')' : '')"
                          [options]="field?.ui_config?.pick_list_values?.length ? field?.ui_config?.pick_list_values : picklistOptions[field?.name]"
                          [parentFormGroup]="selectedSectionLineBlockFormGroup"
                          class="mb-[20px]"
                        />
                        <!-- Text Area Type -->
                        <app-text-area
                          *ngSwitchCase="'textarea'"
                          [controlName]="field?.name"
                          [id]="field?.name+'_'+ i"
                          [label]="field?.label + (field?.uom ? ' (' + field?.uom + ')' : '')"
                          [parentFormGroup]="selectedSectionLineBlockFormGroup"
                          class=" col-span-2 mb-[20px]"
                        />
                        <!-- Boolean -->
                        <div
                          *ngSwitchCase="'boolean'"
                          [id]="field?.name+'_'+ i"
                          class="flex flex-row justify-between items-center  gap-[20px] w-full col-span-2 mb-[30px]">
                          <div class="boolean-label text-type-13 ">
                            {{ field?.label + (field?.uom ? ' (' + field?.uom + ')' : '') }}
                          </div>
                          <mat-slide-toggle
                            (change)="onToggleSectionField($event, field?.name)"
                            [checked]="selectedSectionLineBlockFormGroup?.controls?.[field?.name]?.value"
                            [disableRipple]="false"
                            class="slide-toggle-btn"
                            color="primary"
                          />
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </ng-container>
                <app-pictures-section
                  (onDelete)="deletePicture($event)"
                  *ngIf="selectedMediaFiles?.length"
                  [pictures]="selectedMediaFiles"
                  [isEditable]="!readOnly"
                  class="pictures-section mb-[40px]"
                />
                <div
                  *ngIf="!readOnly"
                  (click)="deleteSectionLine(sslk?.key)"
                  class="flex flex-row justify-between items-center mb-[20px]"
                >
                  <div class="section-heading text-type-8 !text-[#60698b]"></div>
                  <div class="add-station-block flex flex-row justify-start items-center cursor-pointer w-fit">
                    <mat-icon class="icon blue-icon mr-[5px]" svgIcon="trash" />
                    <span
                      class="text-type-9"> {{ formTypeDetails?.ui_config?.delete_line_label || 'Delete entry' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <hr *ngIf="!last" class="hr mb-[20px]">
  </div>
  <div
    *ngIf="displayCommentSection"
    class="comment-section mb-[40px]"
  >
    <app-text-area
      [parentFormGroup]="form"
      controlName="comment"
      label="COMMENT"
    />
  </div>
  <app-pictures-section
    (onDelete)="deletePicture($event)"
    *ngIf="mediaFiles?.length"
    [pictures]="mediaFiles"
    [isEditable]="!readOnly"
    class="pictures-section mb-[40px]"
  />
  <app-location-station-card
    (cardClicked)="openLocationOrStationDetails()"
    (onDelete)="deleteLocation()"
    *ngIf="!displayStationRange && showLocationSection()"
    [form]="form"
    [isEditable]="!readOnly"
    [latitude]="form?.controls?.latitude?.value"
    [longitude]="form?.controls?.longitude?.value"
    [useExternalClickHandler]="false"
    [recordLabel]="'form'"
    [featureSource]="featureSource"
    class="location-section mb-[40px]"
  />
</div>
